import React from 'react'
import styles from './NotificationsManager.module.scss'
import Notification from './Notification'
import { NotificationsManagerProps } from './types'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

const NotificationsManager = (props: NotificationsManagerProps) => (
  <TransitionGroup className={styles['notifications-manager']}>
    {props.notifications.map(({ id, text }) => (
      <CSSTransition
        key={id}
        timeout={500}
        classNames={{
          enter: styles['notification-enter'],
          enterActive: styles['notification-enter-active'],
          exit: styles['notification-exit'],
          exitActive: styles['notification-exit-active']
        }}
      >
        <Notification text={text} />
      </CSSTransition>
    ))}
  </TransitionGroup>
)

export default NotificationsManager
